import TYPES from '@/modules/shared/types';

// Domain
import { AllianzAccountReportRepository } from '../../domain/repository';
import { AllianzAccountReportEntity } from '../../domain/entities/allianz-account-report-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzAccountReportHttpRepository implements AllianzAccountReportRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/allianz-account-report/{CUSTOMER_ID}/`;

  execute(customer_id: string): Promise<Array<AllianzAccountReportEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{CUSTOMER_ID}', customer_id))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
